// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WorkspaceProfilePopup__scroll-container-a66346 {
  position: relative;
  overflow: auto;
}

.WorkspaceProfilePopup__close-dedafd {
  position: absolute;
  top: 16px;
  inset-inline-end: 16px;
}

.WorkspaceProfilePopup__profile-meta-block-ccccef {
  --meta-block-actions-background: var(--base-10);
  padding-inline-start: 24px;
  padding-inline-end: 24px;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/WorkspaceProfilePopup/WorkspaceProfilePopup.styles.m.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,cAAA;AACF;;AAEA;EACE,kBAAA;EACA,SAAA;EACA,sBAAA;AACF;;AAEA;EACE,+CAAA;EACA,0BAAA;EACA,wBAAA;AACF","sourcesContent":[".scroll-container {\n  position: relative;\n  overflow: auto;\n}\n\n.close {\n  position: absolute;\n  top: 16px;\n  inset-inline-end: 16px;\n}\n\n.profile-meta-block {\n  --meta-block-actions-background: var(--base-10);\n  padding-inline-start: 24px;\n  padding-inline-end: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scroll-container": `WorkspaceProfilePopup__scroll-container-a66346`,
	"scrollContainer": `WorkspaceProfilePopup__scroll-container-a66346`,
	"close": `WorkspaceProfilePopup__close-dedafd`,
	"profile-meta-block": `WorkspaceProfilePopup__profile-meta-block-ccccef`,
	"profileMetaBlock": `WorkspaceProfilePopup__profile-meta-block-ccccef`
};
module.exports = ___CSS_LOADER_EXPORT___;
